import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import type { ReceiptLibraryFilter } from "utils/receipts/receiptFormat";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface ReceiptLibraryHeadingProps {
  activeTab: ReceiptLibraryFilter;
}

const ReceiptLibraryHeading: React.FC<ReceiptLibraryHeadingProps> = ({
  activeTab,
}) => {
  const { t } = useTranslation();

  const title = useMemo(() => {
    switch (activeTab) {
      case "ALL":
        return t("Review your receipts");
      case "UNMATCHED":
        return t("We were not able to find a match");
      case "SCAN_FAILED":
        return t("We couldn’t read these receipts");
      default:
        return t("Review your receipts");
    }
  }, [activeTab, t]);

  const subText = useMemo(() => {
    switch (activeTab) {
      case "ALL":
        return t(
          "Review and complete missing or unmatched details to connect receipts to transactions",
        );
      case "UNMATCHED":
        return t("ReceiptDetailsUnmatched");
      case "SCAN_FAILED":
        return t("Please add the missing details to connect to transactions");
      default:
        return t(
          "Review and complete missing or unmatched details to connect receipts to transactions",
        );
    }
  }, [activeTab, t]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-1)",
        paddingBottom: "var(--space-7)",
      }}
    >
      <Typography variant="h5" component="span">
        {title}
      </Typography>
      <Typography
        variant="body2"
        component="span"
        sx={{ color: "var(--color-text-secondary)" }}
      >
        {subText}
      </Typography>
    </Box>
  );
};

export default ReceiptLibraryHeading;
